/*
 * Eventos de e-commerce GA4 + Meta Pixel — payloads idênticos aos helpers
 * de AnalyticsWrapper.tsx (moeda BRL). O bootstrap de gtag/fbq acontece no
 * snippet analytics.liquid, no <head>.
 */
function trackGA4Event(eventName, eventParams) {
  if (window.gtag) window.gtag('event', eventName, eventParams);
}

function trackMetaPixelEvent(eventName, eventParams) {
  if (window.fbq) window.fbq('track', eventName, eventParams);
}

function trackAddToCart(product) {
  trackGA4Event('add_to_cart', {
    currency: 'BRL',
    value: product.price,
    items: [
      {
        item_id: product.id,
        item_name: product.title,
        item_variant: product.variant,
        quantity: product.quantity || 1,
        price: product.price,
      },
    ],
  });
  trackMetaPixelEvent('AddToCart', {
    content_ids: [product.id],
    content_name: product.title,
    content_type: 'product',
    value: product.price,
    currency: 'BRL',
  });
}

function trackViewContent(product) {
  trackGA4Event('view_item', {
    currency: 'BRL',
    value: product.price,
    items: [
      {
        item_id: product.id,
        item_name: product.title,
        item_category: product.category,
        price: product.price,
      },
    ],
  });
  trackMetaPixelEvent('ViewContent', {
    content_ids: [product.id],
    content_name: product.title,
    content_type: 'product',
    value: product.price,
    currency: 'BRL',
  });
}

function trackBeginCheckout(cart) {
  trackGA4Event('begin_checkout', {
    currency: 'BRL',
    value: cart.total,
    items: cart.items.map((item) => ({
      item_id: item.id,
      item_name: item.title,
      price: item.price,
      quantity: item.quantity,
    })),
  });
  trackMetaPixelEvent('InitiateCheckout', {
    content_ids: cart.items.map((item) => item.id),
    content_type: 'product',
    value: cart.total,
    currency: 'BRL',
    num_items: cart.items.reduce((sum, item) => sum + item.quantity, 0),
  });
}

window.HighAnalytics = {trackAddToCart, trackViewContent, trackBeginCheckout};

export {trackAddToCart, trackViewContent, trackBeginCheckout};
